<template>
  <v-container grid-list-xl class="pa-5">
    <v-alert v-if="is_premium" dense text class="body-2 mb-5" type="info">
      Berikut ini merupakan daftar pengguna yang terindikasi melakukan kecurangan absensi.
    </v-alert>

    <m-card-list
      two-line
      title="Laporan Indikasi Kecurangan"
      label-cari="Cari Pengguna"
      edit
      filter
      search
      :items="items"
      :headers="headers"
      refresh
      @refresh="load"
      :page="page"
      footer
      @search="
        (search) => {
          textSearch = search
          load()
        }
      "
      @change:page="
        (pg) => {
          cp = pg
          load()
        }
      "
    >
      <template v-slot:info_filter>
        <div v-if="hasActiveFilter" class="d-flex align-center flex-wrap gap-2">
          <!-- Tanggal Awal -->
          <v-chip
            v-if="filters.tgl_awal"
            small
            close
            @click:close="
              filters.tgl_awal = null
              cp = 1
              load()
            "
            class="mr-1"
          >
            Mulai {{ pVal(filters, 'tgl_awal') | toSDN }}
          </v-chip>

          <!-- Tanggal Akhir -->
          <v-chip
            v-if="filters.tgl_akhir"
            small
            close
            @click:close="
              filters.tgl_akhir = null
              cp = 1
              load()
            "
            class="mr-1"
          >
            Sampai {{ pVal(filters, 'tgl_akhir') | toSDN }}
          </v-chip>

          <!-- Organisasi -->
          <v-chip
            v-if="filters.organisasi_id"
            small
            close
            @click:close="
              filters.organisasi_id = null
              cp = 1
              load()
            "
            class="mr-1"
          >
            {{ filteredOrganisasiName }}
          </v-chip>

          <!-- Jenis Indikasi -->
          <v-chip
            v-for="jenis in filters.jenis_indikasi"
            :key="jenis"
            small
            close
            class="mr-1"
            @click:close="removeJenisIndikasi(jenis)"
          >
            {{ INDIKASI_LABELS[jenis] }}
          </v-chip>

          <!-- Level Indikasi -->
          <v-chip
            v-if="filters.level"
            :color="FRAUD_COLORS[filters.level]"
            text-color="white"
            small
            close
            class="mr-1"
            @click:close="
              filters.level = null
              cp = 1
              load()
            "
          >
            {{ levelLabel }}
          </v-chip>

          <!-- Clear All Button -->
          <v-btn v-if="activeFilterCount > 1" x-small text color="error" @click="clearAllFilters">
            <v-icon small>mdi-close-all</v-icon>
          </v-btn>
        </div>
      </template>
      <template v-slot:action_ext>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" class="rounded ml-3 pa-5 grey lighten-3" depressed small icon @click="openFilterDialog">
              <v-icon>mdi-filter</v-icon>
            </v-btn>
          </template>
          <span>Filter Indikasi Kecurangan</span>
        </v-tooltip>
      </template>
      <template v-slot:items="{ props, item }">
        <tr v-if="$vuetify.breakpoint.smAndUp">
          <td class="py-3 px-4">
            <div class="d-flex align-center">
              <v-btn
                text
                small
                color="primary"
                class="font-weight-bold text-none pa-0 justify-start user-name"
                :loading="loadingDetailId === getPresensiId(item)"
                :disabled="!!loadingDetailId"
                @click="openDetail(item)"
              >
                {{ pVal(item.user, 'nama') }}
              </v-btn>
              <v-tooltip v-if="Number(item.is_aktif) === 0" top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon color="error" x-small class="ml-1">
                    <v-icon small>mdi-information</v-icon>
                  </v-btn>
                </template>
                <span>Pengguna Tidak Aktif</span>
              </v-tooltip>
            </div>
            <div class="text-caption text--secondary text-truncate">{{
              getDeepObj(item, 'nama_perangkat') || '-'
            }}</div>
          </td>
          <td class="py-3 px-4 text-no-wrap">
            <div>{{ item.waktu_scan.slice(0, 11) | toD }}</div>
            <div class="text-caption text--secondary">{{ $setTimezone(item.waktu_scan, 2) }}</div>
          </td>
          <td class="py-3 px-4">
            <div>{{ getDeepObj(item, 'organisasi.nama') || '-' }}</div>
          </td>
          <td class="py-3 px-4 text-no-wrap">
            {{ pVal(item, 'version_code') || '-' }}
          </td>
          <td class="py-3 px-4">
            <v-btn
              v-if="item.latitude && item.longitude"
              x-small
              depressed
              :color="item.nama_lokasi ? 'success' : 'primary'"
              class="text-none px-2 pa-0 maps-action"
              @click="toMaps(item.latitude, item.longitude)"
            >
              <v-icon x-small left>mdi-google-maps</v-icon>
              {{ item.nama_lokasi || 'Cek Lokasi' }}
            </v-btn>
            <div v-if="item.latitude && item.longitude" class="text-caption text--secondary mt-1">
              Lat: {{ item.latitude }}, <br />Long: {{ item.longitude }}
            </div>
            <span v-if="!item.latitude || !item.longitude" class="text-caption text--secondary">-</span>
          </td>
          <td class="py-3 px-4 text-center">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  fab
                  depressed
                  x-small
                  color="primary"
                  :loading="loadingDetailId === getPresensiId(item)"
                  :disabled="!!loadingDetailId"
                  @click="openDetail(item)"
                >
                  <v-icon small>mdi-eye</v-icon>
                </v-btn>
              </template>
              <span>Lihat Detail</span>
            </v-tooltip>
          </td>
        </tr>
        <tr v-else>
          <td class="v-data-table__mobile-row">
            <div class="v-data-table__mobile-row__header mr-2">
              {{ headers[0].text }}
            </div>
            <div class="v-data-table__mobile-row__cell">
              <v-btn
                text
                small
                color="primary"
                class="font-weight-bold text-none pa-0 justify-end"
                :loading="loadingDetailId === getPresensiId(item)"
                :disabled="!!loadingDetailId"
                @click="openDetail(item)"
              >
                {{ pVal(item.user, 'nama') }}
              </v-btn>
              <div class="text-caption text--secondary">{{ getDeepObj(item, 'nama_perangkat') || '-' }}</div>
            </div>
          </td>
          <td class="v-data-table__mobile-row">
            <div class="v-data-table__mobile-row__header mr-2">
              {{ headers[1].text }}
            </div>
            <div class="v-data-table__mobile-row__cell">
              <div>{{ item.waktu_scan.slice(0, 11) | toD }}</div>
              <div class="text-caption text--secondary">{{ $setTimezone(item.waktu_scan, 2) }}</div>
            </div>
          </td>
          <td class="v-data-table__mobile-row">
            <div class="v-data-table__mobile-row__header mr-2">
              {{ headers[2].text }}
            </div>
            <div class="v-data-table__mobile-row__cell">
              {{ getDeepObj(item, 'organisasi.nama') || '-' }}
            </div>
          </td>
          <td class="v-data-table__mobile-row">
            <div class="v-data-table__mobile-row__header mr-2">
              {{ headers[3].text }}
            </div>
            <div class="v-data-table__mobile-row__cell">
              {{ pVal(item, 'version_code') || '' }}
            </div>
          </td>
          <td class="v-data-table__mobile-row">
            <div class="v-data-table__mobile-row__header mr-2">
              {{ headers[4].text }}
            </div>
            <div class="v-data-table__mobile-row__cell">
              <div v-if="item.latitude && item.longitude" class="text-caption text--secondary mb-1">
                {{ item.latitude }}, {{ item.longitude }}
              </div>
              <v-btn
                v-if="item.latitude && item.longitude"
                x-small
                outlined
                rounded
                color="primary"
                class="text-none px-2 maps-action"
                @click="toMaps(item.latitude, item.longitude)"
              >
                <v-icon x-small left>mdi-google-maps</v-icon>
                {{ pVal(item, 'nama_lokasi') || 'Maps' }}
              </v-btn>
              <span v-if="!item.latitude || !item.longitude" class="text-caption text--secondary">-</span>
            </div>
          </td>
          <td class="v-data-table__mobile-row">
            <div class="v-data-table__mobile-row__header mr-2">
              {{ headers[5].text }}
            </div>
            <div class="v-data-table__mobile-row__cell">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    icon
                    small
                    color="primary"
                    class="mx-2"
                    :loading="loadingDetailId === getPresensiId(item)"
                    :disabled="!!loadingDetailId"
                    @click="openDetail(item)"
                  >
                    <v-icon small>mdi-eye</v-icon>
                  </v-btn>
                </template>
                <span>Lihat Detail</span>
              </v-tooltip>
            </div>
          </td>
        </tr>
      </template>
    </m-card-list>

    <!-- Filter Component -->
    <FilterKecurangan
      ref="filterDialog"
      :list-organisasi="listOrganisasi"
      :loading-organisasi="loadingOrganisasi"
      @filter="handleFilter"
    />
    <DetailIndikasiCurang ref="detailDialog" />
  </v-container>
</template>

<script>
import BlockCard from '@/components/BlockCard'
import FilterKecurangan from '@/modules/indikasiCurang/components/Filter.vue'
import DetailIndikasiCurang from '@/modules/indikasiCurang/components/Detail.vue'
import { FRAUD_COLORS, FRAUD_LABELS, INDIKASI_LABELS } from '@/modules/indikasiCurang/const'

export default {
  components: {
    BlockCard,
    FilterKecurangan,
    DetailIndikasiCurang,
  },
  data() {
    return {
      items: [],
      textSearch: null,
      page: null,
      cp: 1,
      // Filter state
      filters: {
        tgl_awal: null,
        tgl_akhir: null,
        organisasi_id: null,
        organisasi_nama: null,
        jenis_indikasi: [],
        level: null,
      },
      // Organisasi list
      listOrganisasi: [],
      loadingOrganisasi: false,
      loadingDetailId: null,
      headers: [
        { text: 'Nama Pengguna', align: 'left', value: 'user', width: '26%' },
        { text: 'Tanggal Presensi', align: 'left', value: 'waktu_scan', width: '18%' },
        { text: 'Nama Organisasi', align: 'left', value: 'organisasi', width: '22%' },
        { text: 'Versi', align: 'left', value: 'version_code', width: '15%' },
        { text: 'Lokasi', align: 'left', value: 'nama_lokasi', width: '18%' },
        { text: 'Aksi', align: 'center', value: 'aksi', width: '10%' },
      ],
      fraudColors: FRAUD_COLORS,
      fraudLabels: FRAUD_LABELS,
      INDIKASI_LABELS,
      FRAUD_COLORS, // For template access
    }
  },
  computed: {
    // Get level label
    levelLabel() {
      if (!this.filters.level) return null
      return FRAUD_LABELS[this.filters.level]
    },
    // Check if any filter is active
    hasActiveFilter() {
      return (
        this.filters.tgl_awal ||
        this.filters.tgl_akhir ||
        this.filters.organisasi_id ||
        this.filters.jenis_indikasi.length ||
        this.filters.level
      )
    },
    // Get active filter count
    activeFilterCount() {
      let count = 0
      if (this.filters.tgl_awal) count++
      if (this.filters.tgl_akhir) count++
      if (this.filters.organisasi_id) count++
      count += this.filters.jenis_indikasi.length
      if (this.filters.level) count++
      return count
    },
    filteredOrganisasiName() {
      if (!this.filters.organisasi_id) return null
      const org = this.listOrganisasi.find((o) => o.organisasi_id === this.filters.organisasi_id)
      return org ? org.nama : null
    },
  },
  mounted() {
    this.load()
  },
  methods: {
    removeJenisIndikasi(jenis) {
      this.filters.jenis_indikasi = this.filters.jenis_indikasi.filter((item) => item !== jenis)
      this.cp = 1
      this.load()
    },
    load() {
      const loadParams = {
        page: this.cp,
        keyword: this.textSearch,
        tgl_awal: this.filters.tgl_awal,
        tgl_akhir: this.filters.tgl_akhir,
        organisasi_id: this.filters.organisasi_id,
        level: this.filters.level,
      }
      if (this.filters.jenis_indikasi.includes('versi')) loadParams.version_score = 1
      if (this.filters.jenis_indikasi.includes('lokasi')) loadParams.lokasi_score = 1
      this.$store
        .dispatch('indikasiCurang/get', {
          tenant_id: this.tenant_id,
          params: loadParams,
        })
        .then((res) => {
          this.page = res.data
          this.items = res.data.data
        })
        .catch((e) => e)
    },
    handleFilter(filterData) {
      // Update filter state
      this.filters = {
        tgl_awal: filterData.tgl_awal,
        tgl_akhir: filterData.tgl_akhir,
        organisasi_id: filterData.organisasi_id,
        organisasi_nama: filterData.organisasi_nama,
        jenis_indikasi: filterData.jenis_indikasi || [],
        level: filterData.level,
      }
      // Reset page ke 1 saat filter berubah
      this.cp = 1
      // Load data dengan filter baru
      this.load()
    },
    clearAllFilters() {
      this.filters = {
        tgl_awal: null,
        tgl_akhir: null,
        organisasi_id: null,
        organisasi_nama: null,
        jenis_indikasi: [],
        level: null,
      }
      this.cp = 1
      this.load()
    },
    openFilterDialog() {
      this.loadingOrganisasi = true
      this.$store
        .dispatch('organisasi/getFilterOrganisasi')
        .then(({ data }) => {
          // Handle response - could be array or object with data property
          this.listOrganisasi = data.data || []
          this.loadingOrganisasi = false
          // Open filter dialog setelah data selesai di-load
          this.$refs.filterDialog.open()
        })
        .catch((err) => {
          console.error('Error fetching organisasi:', err)
          this.loadingOrganisasi = false
          // Tetap buka dialog meskipun error
          this.$refs.filterDialog.open()
        })
    },
    toMaps(lat, long) {
      var url = 'http://www.google.com/maps/place/' + lat + ',' + long
      window.open(url, '_blank')
    },
    detailData(item) {
      return item && item.data && typeof item.data === 'object' ? item.data : null
    },
    getPresensiId(item) {
      return item && (item.presensi_id || item.presensi || item.id)
    },
    openDetail(item) {
      const presensi = this.getPresensiId(item)
      if (!presensi) {
        this.$refs.detailDialog.open(item)
        return
      }

      this.loadingDetailId = presensi
      this.$store
        .dispatch('indikasiCurang/detail', {
          tenant_id: this.tenant_id,
          presensi,
        })
        .then((res) => {
          const detail = (res && res.data) || res || {}
          this.$refs.detailDialog.open(Object.assign({}, item, detail))
        })
        .catch(() => {
          this.$error('Gagal mengambil detail indikasi kecurangan')
        })
        .finally(() => {
          this.loadingDetailId = null
        })
    },
  },
}
</script>

<style scoped>
.user-name {
  max-width: 100%;
}

.maps-action {
  height: 22px !important;
  font-size: 11px;
  letter-spacing: 0;
}
</style>
